<div class="d-block" [appStoryblok]="_editable">
  @for (blok of content; track blok) {
    <p [innerHTML]="renderHtml(blok)" [ngClass]="[blok.type, blok.attrs ? 'level_' + blok.attrs.level : '']">
    </p>
    @for (body of blok.attrs?.body; track body) {
      @if (blok.type === 'blok' && blok.attrs) {
        <ndc-dynamic [ndcDynamicComponent]="components[body.component]" [ndcDynamicInputs]="body">
        </ndc-dynamic>
      }
    }
  }
</div>

